/* La Caza Cali: policy pages (/policies/*).
   Shopify fixes the policy markup and each policy was written differently
   (real h2s, bold-line headings, <br>-separated blobs, pasted store-info
   blocks), so this script first normalises the text, then restructures it:
   eyebrow + policy tabs, lead, numbered sections, fact cards for
   "Label: value" lines, on-this-page nav, mailto links, contact card.
   Styles live in lacaza-policy.css and only apply under .lcp. */
(function () {
  var root = document.querySelector('.shopify-policy__container');
  if (!root || root.classList.contains('lcp')) return;

  var titleWrap = root.querySelector('.shopify-policy__title');
  var rte = root.querySelector('.shopify-policy__body .rte');
  if (!titleWrap || !rte) return;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function slug(s) {
    return s.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function kids(node) { return Array.prototype.slice.call(node.children); }
  function isShouting(s) {
    var up = (s.match(/[A-Z]/g) || []).length, low = (s.match(/[a-z]/g) || []).length;
    return up > 3 && up / (up + low) > 0.55;
  }
  function sentence(s) {
    s = s.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  function headingText(s) {
    s = s.replace(/\s+/g, ' ').trim()
      .replace(/^section\s+\d+\s*[-–—:.]\s*/i, '')
      .replace(/[:.]$/, '');
    return isShouting(s) ? sentence(s) : s;
  }

  /* ---------- 1. Normalise ---------- */

  // Pasted store-info blocks (legal name, phone, address) move to a company card
  var company = [];
  rte.querySelectorAll('.store-info__block').forEach(function (b) {
    b.querySelectorAll('h1,h2,h3,h4,h5,h6,p').forEach(function (h) {
      h.innerHTML.split(/<br\s*\/?>/i).forEach(function (line) {
        var t = el('div', null, line).textContent.replace(/\s+/g, ' ').trim();
        if (!t) return;
        var m = t.match(/^([^:]{2,30}):\s*(.+)$/) || t.match(/^(DBA)\s+(.+)$/i) || t.match(/^(Phone(?: number)?)\s+(.+)$/i);
        if (m) company.push([m[1].trim(), m[2].trim()]);
        else company.push(['', t]);
      });
    });
    b.remove();
  });

  // Unwrap plain wrapper divs so content sits directly in .rte
  kids(rte).forEach(function (c) {
    if (c.tagName === 'DIV' && !c.className) {
      while (c.firstChild) rte.insertBefore(c.firstChild, c);
      c.remove();
    }
  });

  // Split <br>-separated paragraphs into real paragraphs
  kids(rte).forEach(function (p) {
    if (p.tagName !== 'P' || !p.querySelector('br')) return;
    var parts = p.innerHTML.split(/(?:\s*<br\s*\/?>\s*)+/i);
    if (parts.length < 2) return;
    parts.forEach(function (html) {
      if (!html.replace(/&nbsp;|\s/g, '')) return;
      p.parentNode.insertBefore(el('p', null, html.trim()), p);
    });
    p.remove();
  });

  // Paragraphs that start with a bold heading line: "<strong>TITLE</strong> text"
  kids(rte).forEach(function (p) {
    if (p.tagName !== 'P') return;
    var first = p.firstElementChild;
    if (!first || !/^(STRONG|B)$/.test(first.tagName)) return;
    var label = first.textContent.trim();
    var rest = p.textContent.slice(p.textContent.indexOf(label) + label.length).trim();
    if (!label || /[:@]/.test(label) || label.length > 80) return; // "Label: value" rows stay
    if (p.textContent.trim().indexOf(label) !== 0) return;
    var h = el('h2', null, headingText(label));
    p.parentNode.insertBefore(h, p);
    first.remove();
    if (rest) p.innerHTML = p.innerHTML.replace(/^\s+/, ''); else p.remove();
  });

  // Other heading levels become h2; shouting headings become sentence case
  kids(rte).forEach(function (h) {
    if (!/^H[1-6]$/.test(h.tagName)) return;
    var t = headingText(h.textContent);
    if (h.tagName !== 'H2') {
      var n = el('h2', null, t);
      h.parentNode.replaceChild(n, h);
    } else if (t !== h.textContent.trim()) {
      h.textContent = t;
    }
  });

  // Drop rules and empty paragraphs
  kids(rte).forEach(function (c) {
    if (c.tagName === 'HR') c.remove();
    else if (c.tagName === 'P' && !c.textContent.replace(/ |\s/g, '') && !c.querySelector('img,a')) c.remove();
  });

  /* ---------- 2. Header ---------- */

  var policies = [
    ['Refunds', '/policies/refund-policy'],
    ['Shipping', '/policies/shipping-policy'],
    ['Privacy', '/policies/privacy-policy'],
    ['Terms', '/policies/terms-of-service']
  ];
  var path = location.pathname.replace(/\/$/, '');
  var tabs = el('nav', 'lcp-tabs');
  tabs.setAttribute('aria-label', 'Policies');
  policies.forEach(function (p) {
    var a = el('a', 'lcp-tab', p[0]);
    a.href = p[1];
    if (path === p[1]) { a.classList.add('is-active'); a.setAttribute('aria-current', 'page'); }
    tabs.appendChild(a);
  });
  var eyebrow = el('p', 'lcp-eyebrow', 'Policies');
  titleWrap.insertBefore(eyebrow, titleWrap.firstChild);
  titleWrap.appendChild(tabs);

  // "Last updated" line joins the eyebrow
  var updated = kids(rte).filter(function (p) { return p.tagName === 'P' && /^\s*last updated/i.test(p.textContent); })[0];
  if (updated) {
    eyebrow.innerHTML = 'Policies <span class="lcp-updated">' + updated.textContent.trim().replace(/:\s*/, ' ') + '</span>';
    updated.remove();
  }

  // Lead: a short opening paragraph before the first heading
  var firstKid = rte.firstElementChild;
  if (firstKid && firstKid.tagName === 'P' && rte.querySelector(':scope > h2') &&
      firstKid.textContent.trim().length < 240 &&
      (!firstKid.nextElementSibling || firstKid.nextElementSibling.tagName === 'H2')) {
    var lead = el('div', 'lcp-lead');
    lead.appendChild(firstKid);
    titleWrap.appendChild(lead);
  }

  /* ---------- 3. Sections ---------- */

  var sections = [];
  // Content before the first h2 becomes an unnumbered intro section
  if (rte.firstElementChild && rte.firstElementChild.tagName !== 'H2') {
    var introSec = el('section', 'lcp-sec lcp-sec--intro');
    rte.insertBefore(introSec, rte.firstElementChild);
    while (introSec.nextElementSibling && introSec.nextElementSibling.tagName !== 'H2') {
      introSec.appendChild(introSec.nextElementSibling);
    }
  }
  var h2s = Array.prototype.slice.call(rte.querySelectorAll(':scope > h2'));
  h2s.forEach(function (h2, i) {
    var sec = el('section', 'lcp-sec');
    var text = h2.textContent.trim();
    sec.id = slug(text) || 'section-' + (i + 1);
    h2.insertBefore(el('span', 'lcp-num', String(i + 1).padStart(2, '0')), h2.firstChild);
    h2.parentNode.insertBefore(sec, h2);
    var n = h2;
    while (n && !(n !== h2 && n.tagName === 'H2')) {
      var next = n.nextElementSibling;
      sec.appendChild(n);
      n = next;
    }
    sections.push({ sec: sec, text: text });
  });

  // "Label: value" paragraphs become a fact card (2+ per section)
  function factCard(rows) {
    var dl = el('dl', 'lcp-facts');
    rows.forEach(function (r) {
      var row = el('div', 'lcp-fact');
      row.appendChild(el('dt', null, r[0]));
      row.appendChild(el('dd', null, r[1]));
      dl.appendChild(row);
    });
    return dl;
  }
  rte.querySelectorAll('.lcp-sec').forEach(function (sec) {
    var rows = kids(sec).filter(function (p) {
      var first = p.firstElementChild;
      return p.tagName === 'P' && first &&
        p.textContent.trim().indexOf(first.textContent.trim()) === 0 &&
        /:\s*$/.test(first.textContent) && first.textContent.length < 40 &&
        p.textContent.length - first.textContent.length > 1;
    });
    if (rows.length < 2) return;
    var data = rows.map(function (p) {
      var first = p.firstElementChild;
      var label = first.textContent.replace(/:\s*$/, '').trim();
      first.remove();
      return [label, p.innerHTML.trim()];
    });
    rows[0].parentNode.insertBefore(factCard(data), rows[0]);
    rows.forEach(function (p) { p.remove(); });
  });

  // Company details card
  if (company.length) {
    var csec = el('section', 'lcp-sec lcp-sec--company');
    csec.id = 'company-details';
    csec.appendChild(el('h2', null, '<span class="lcp-num">' + String(sections.length + 1).padStart(2, '0') + '</span>Company details'));
    csec.appendChild(factCard(company.map(function (r) {
      return [r[0] ? headingText(r[0]).replace(/^Company legal name$/i, 'Legal name').replace(/^Email address$/i, 'Email').replace(/^Registered address$/i, 'Address') : '', r[1]];
    })));
    rte.appendChild(csec);
    sections.push({ sec: csec, text: 'Company details' });
  }

  // Emails become links
  var walker = document.createTreeWalker(rte, NodeFilter.SHOW_TEXT);
  var hits = [];
  while (walker.nextNode()) {
    var t = walker.currentNode;
    if (/[\w.+-]+@[\w-]+\.[\w.]+/.test(t.nodeValue) && !t.parentNode.closest('a')) hits.push(t);
  }
  hits.forEach(function (t) {
    var span = document.createElement('span');
    span.innerHTML = t.nodeValue.replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/([\w.+-]+@[\w-]+\.[\w.]*\w)/g, '<a href="mailto:$1">$1</a>');
    t.parentNode.replaceChild(span, t);
  });

  // Closing contact card: reuse a closing "Questions?" section, else add one
  var actionsHtml = '<a class="lcp-btn lcp-btn--ink" href="mailto:info@lacazacali.com">Email us</a>' +
    '<a class="lcp-btn" href="/pages/contact">Contact page</a>';
  var last = sections[sections.length - 1];
  var cta;
  if (last && /question|^contact/i.test(last.text)) {
    cta = last.sec;
    cta.querySelectorAll(':scope > p').forEach(function (p) {
      if (/^\s*email:/i.test(p.textContent)) p.remove();
    });
    sections.pop();
  } else if (!/contact-information/.test(path)) {
    cta = el('section', 'lcp-sec');
    cta.appendChild(el('h2', null, 'Questions?'));
    cta.appendChild(el('p', null, 'Email <a href="mailto:info@lacazacali.com">info@lacazacali.com</a> and we will get back to you within 2 business days.'));
    rte.appendChild(cta);
  }
  if (cta) {
    cta.classList.add('lcp-sec--cta');
    cta.id = cta.id || 'questions';
    cta.appendChild(el('div', 'lcp-actions', actionsHtml));
  }

  /* ---------- 4. Layout + on-this-page nav ---------- */

  var side = el('div', 'lcp-side');
  root.insertBefore(side, titleWrap);
  side.appendChild(titleWrap);

  if (sections.length > 2) {
    root.classList.add('lcp--split');
    var toc = el('details', 'lcp-toc');
    toc.open = window.matchMedia('(min-width: 990px)').matches;
    toc.appendChild(el('summary', null, 'On this page'));
    var ol = el('ol');
    sections.forEach(function (s) {
      var li = el('li');
      var a = el('a', null, s.text);
      a.href = '#' + s.sec.id;
      li.appendChild(a); ol.appendChild(li);
    });
    toc.appendChild(ol);
    side.appendChild(toc);

    if ('IntersectionObserver' in window) {
      var links = ol.querySelectorAll('a');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) {
            var hit = a.getAttribute('href') === '#' + e.target.id;
            a.classList.toggle('is-active', hit);
            if (hit && toc.open && side.scrollHeight > side.clientHeight) {
              var top = a.offsetTop - side.clientHeight / 2;
              side.scrollTo({ top: top, behavior: 'smooth' });
            }
          });
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      sections.forEach(function (s) { io.observe(s.sec); });
    }
  }

  root.classList.add('lcp');
})();
